export type AssessoriaDurada = '<30min' | '30_60min' | '60_90min' | '+90min';

export enum AssessoriaDuradaEnum {
  '<30min' = '< 30min.',
  '30_60min' = '30-60min.',
  '60_90min' = '60-90min.',
  '+90min' = '+90min.',
}
